export const defaultSingleObjectState: SingleObjectState = {
  processing: false,
  processed: false,
  success: false,
  errors: {},
  data: {},
  message: "",
};
export interface SelectMainOption {
  readonly value: string;
  readonly label: string;
}
export interface LanguageType {
  id: string;
  name: string;
  slug: string;
  aliases?: string[];
  iso6391?: string | null;
  iso6393?: string | null;
  active: boolean;
  sortOrder: number;
  createdAt: Date;
  updatedAt: Date;
}
export type CategoryGroup = "Mass Parts" | "Seasons" | "Others" | null;

export interface CategoryType {
  id: string;
  name: string;
  slug: string;
  group: CategoryGroup;
  active: boolean;
  sortOrder: number;
  createdAt: Date;
  updatedAt: Date;
}
export const defaultSingleObjectPayload: Readonly<{
  data: GenericRecord;
  errors: Record<string, unknown>;
}> = {
  data: {},
  errors: {},
};

export const defaultManyObjectPayload = {
  data: [],
  errors: [],
  paginationMeta: {
    currentPage: 0,
    nextPage: null,
    previousPage: null,
    totalObjects: 0,
    totalPages: 0,
    maxObjectsPerPage: 0,
  },
};

export const defaultManyObjectState: ManyObjectState = {
  processing: false,
  processed: false,
  success: false,
  errors: {},
  data: [],
  message: "",
};

export const defaultPaginatedObjectState: ManyObjectState = {
  ...defaultManyObjectState,
  paginationMeta: {
    currentPage: 0,
    nextPage: null,
    previousPage: null,
    totalObjects: 0,
    totalPages: 0,
    maxObjectsPerPage: 0,
  },
};

export const DEFAULT_AVATAR_IMAGE = "/emptyStates/avatar.jpeg";

export const DEFAULT_POST_IMAGE =
  "https://redzonekickboxing.com/wp-content/uploads/2017/04/default-image.jpg";

export const IMAGE_USED_IN_STORY_DOCS =
  "https://avatars3.githubusercontent.com/u/38565349?s=60&v=4";
export const UNSPLASH_IMAGE_ONE =
  "https://images.unsplash.com/photo-1602696221981-75511960e2b6?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=3334&q=80";

export const UNSPLASH_IMAGE_TWO =
  "https://images.unsplash.com/photo-1602609777860-f36a617a194f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=934&q=80";

export const UNSPLASH_IMAGE_THREE =
  "https://images.unsplash.com/photo-1602731882832-9e04d741078f?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2100&q=80";
export const LINKEDIN = "https://www.linkedin.com/company/npo-hub";
export const TWITTER = "https://twitter.com/hubnpo?lang=en";
export const INSTAGRAM = "https://www.instagram.com/npo_hub/";

export const MassParts = [
  "All",
  "Entrance",
  "Lord have Mercy",
  "Glory be to God",
  "Responsorial Psalm",
  "Gospel Acclamation",
  "I Believe (Credo)",
  "Prayer of the Faithful",
  "Offertory",
  "Consecration",
  "Holy Holy Holy",
  "Lamb of God",
  "Communion",
  "Recessional",
];

export const seasons = [
  "Ordinary Time",
  "Advent",
  "Christmas",
  "Lent",
  "Easter",
  "Pentecost",
  "Feast Days",
];

export const others = [
  "Classical",
  "Marian",
  "Wedding",
  "Funeral",
  "Eucharistic Adoration",
  "Benediction",
  "Taize",
];

export const AllCategories = [...MassParts, ...seasons, ...others];
export const languages = ["Igbo", "Yoruba", "Hausa", "Other Lang"];

export const AUDIO_FILE_OPTIONS = [".mp3", ".wav", ".ogg"];
export const CURRENT_PAGE = "my-page";

export const userKey = "user-token";
export const userInfo = "user-detail-info";
export const statusOBJ = {
  PENDING: "Pending",
  APPROVED: "Published",
  REJECTED: "Cancelled",
};
export const languageOptions: readonly SelectMainOption[] = [
  { value: "English", label: "English" },
  { value: "Pidgin English", label: "Pidgin English" },
  { value: "Hausa", label: "Hausa" },
  { value: "Yoruba", label: "Yoruba" },
  { value: "Igbo", label: "Igbo" },
  { value: "Fulfulde", label: "Fulfulde" },
  { value: "Kanuri", label: "Kanuri" },
  { value: "Tiv", label: "Tiv" },
  { value: "Efik", label: "Efik" },
  { value: "Ibibio", label: "Ibibio" },
  { value: "Edo", label: "Edo" },
  { value: "Igala", label: "Igala" },
  { value: "Nupe", label: "Nupe" },
  { value: "Swahili", label: "Swahili" },
  { value: "Amharic", label: "Amharic" },
  { value: "Oromo", label: "Oromo" },
  { value: "Somali", label: "Somali" },
  { value: "Tigrinya", label: "Tigrinya" },
  { value: "Akan", label: "Akan" },
  { value: "Twi", label: "Twi" },
  { value: "Ewe", label: "Ewe" },
  { value: "Wolof", label: "Wolof" },
  { value: "Lingala", label: "Lingala" },
  { value: "Kinyarwanda", label: "Kinyarwanda" },
  { value: "Luganda", label: "Luganda" },
  { value: "Shona", label: "Shona" },
  { value: "Zulu", label: "Zulu" },
  { value: "Xhosa", label: "Xhosa" },
  { value: "Sesotho", label: "Sesotho" },
  { value: "French", label: "French" },
  { value: "Portuguese", label: "Portuguese" },
  { value: "Latin", label: "Latin" },
  { value: "Other", label: "Other" },
];

export const QUERY_KEYS = {
  ADMIN_SCRIPTS: "GET_ADMIN_SCRIPTS",
  LANGUAGES: "GET_LANGUAGES",
  USER_ANALYTICS: "GET_USER_ANALYTICS",
  DOWNLOAD_HISTORY: "GET_DOWNLOAD_HISTORY",
  REVENUE_ANALYTICS: "GET_GENERATED_REVENUE",
  USER_SUMMARY: "GET_USER_SUMMARY",
  SUBSCRIPTION_PLAN: "GET_SUBSCRIPTION_PLAN",
  SINGLE_PURCHASES: "GET_SINGLE_PURCHASES",
  EDIT_REQUESTS: "GET_EDIT_REQUESTS",
};

export type EditRequestStatus = "pending" | "approved" | "discarded";

export interface EditRequestFieldGroup {
  key: string;
  label: string;
  keys: string[];
}

export const EDIT_REQUEST_FIELD_LABELS: Record<string, string> = {
  name: "Script Name",
  composer: "Composer",
  composerId: "Composer ID",
  description: "Description",
  meta: "Lyrics / Meta",
  keySignature: "Key Signature",
  parts: "Parts / Voicing",
  category: "Category",
  categories: "Categories",
  customCategory: "Custom Category",
  categoryIds: "Catalogue Categories",
  language: "Language",
  languages: "Languages",
  languageIds: "Catalogue Languages",
  license: "License",
  document: "Document / Sheet Music (PDF)",
  audio: "Audio Preview",
  image: "Cover Image",
  videoUrl: "Video URL",
};

export const EDIT_REQUEST_FIELD_GROUPS: EditRequestFieldGroup[] = [
  { key: "name", label: "Script Name", keys: ["name"] },
  { key: "composer", label: "Composer", keys: ["composer", "composerId"] },
  { key: "description", label: "Description", keys: ["description"] },
  { key: "meta", label: "Lyrics / Meta", keys: ["meta"] },
  { key: "category", label: "Category", keys: ["category", "customCategory", "categoryIds"] },
  { key: "language", label: "Language", keys: ["language", "languageIds"] },
];

export const getEditRequestFieldGroups = (
  proposedChanges: Record<string, any> = {},
): EditRequestFieldGroup[] => {
  const proposedKeys = Object.keys(proposedChanges);
  const groups: EditRequestFieldGroup[] = [];
  const handledKeys = new Set<string>();

  for (const group of EDIT_REQUEST_FIELD_GROUPS) {
    const presentKeys = group.keys.filter((key) => proposedKeys.includes(key));
    if (presentKeys.length > 0) {
      groups.push({
        key: group.key,
        label: group.label,
        keys: presentKeys,
      });
      presentKeys.forEach((key) => {
        handledKeys.add(key);
      });
    }
  }

  for (const key of proposedKeys) {
    if (!handledKeys.has(key)) {
      groups.push({
        key,
        label: EDIT_REQUEST_FIELD_LABELS[key] ?? key,
        keys: [key],
      });
    }
  }

  return groups;
};

export interface EditRequestType {
  id: string;
  scriptId: string;
  userId?: string;
  status: EditRequestStatus;
  proposedChanges: Record<string, any>;
  script?: ScriptType;
  user?: {
    id?: string;
    userName?: string;
    email?: string;
  };
  reviewedBy?: string;
  reviewedAt?: string | Date;
  resolvedFields?: Record<string, "approved" | "cancelled" | "discarded" | string>;
  fullyResolved?: boolean;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export interface ScriptType {
  meta: string;
  id: string;
  name: string;
  composer: string;
  image: string;
  document: string;
  audio: string;
  composerId: string;
  videoUrl: string;
  keySignature: string;
  language: string | null;
  languageIds?: string[];
  languages?: LanguageType[];
  categoryIds?: string[];
  categories?: CategoryType[];
  license: string;
  parts: string;
  uploadedBy: string;
  category: string;
  customCategory: string;
  description: string;
  slug: string;
  isVerified: string;
  hasEditRequest?: boolean;
  editRequestId?: string | null;
  ratingCount: number;
  averateRating: number;
  viewCount: number;
  downloadCount: number;
  favoriteCount: number;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  user: {
    userName: string;
    email: string;
  };
}

export interface UserType {
  id: string;
  userName: string;
  displayName: string;
  email: string;
  image: string;
  isVerified: string;
  status: string;
  resetPasswordToken: string;
  resetPasswordExpire: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date;
  isSubscribed: string;
  subscribtion?: {
    startDate?: Date;
    endDate?: Date;
    userDownloadCount?: 0;
    status?: string;
  };
}
